"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeModelCollection = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var id_1 = require("../../id");
var collection_data_1 = require("./collection.data");
var collection_loader_1 = require("./collection.loader");
var capture_provider_1 = require("./fields/provider/capture.provider");
var collection_provider_1 = require("./fields/provider/collection.provider");
var collection_model_read_1 = require("./serializer/collection.model.read");
var ReadUtil = tslib_1.__importStar(require("./serializer/collection.model.util"));
var collection_model_write_1 = require("./serializer/collection.model.write");
var collection_upgrade_1 = require("./upgrade/collection.upgrade");
var IkeModelCollection = /** @class */ (function () {
    function IkeModelCollection() {
    }
    IkeModelCollection.prototype.loader = function () {
        return new collection_loader_1.IkeCollectionLoaderFromState();
    };
    IkeModelCollection.prototype.upgrade = function (collections, targetForm) {
        return new collection_upgrade_1.IkeCollectionUpgrade(collections, targetForm);
    };
    IkeModelCollection.prototype.create = function (form, loader) {
        var collection = new collection_data_1.CollectionModel(form, loader);
        collection.state.uuid = id_1.IkeId.v4();
        collection.state.revision = collection.state.instanceId = id_1.IkeId.generate();
        collection.state.createdAt = collection.state.updatedAt = new Date();
        return collection;
    };
    IkeModelCollection.prototype.read = function (collection, schema, loader) {
        var reader = new collection_model_read_1.IkeModelCollectionReader(collection, schema, loader);
        return reader.read();
    };
    IkeModelCollection.prototype.write = function (model) {
        var collectionJSON = {
            objectId: model.id,
            v: IkeModelCollection.JSON_VERSION_LATEST,
            uuid: model.uuid,
            data: {
                recordeduuid: model.uuid,
                uuid: model.schema.rootFormId,
                version: model.schema.revision,
                data: collection_model_write_1.IkeModelCollectionWriter.writeData(model)
            },
            formuuid: model.schema.rootFormId,
            formversion: model.schema.revision,
            jobuuid: model.jobId,
            measurements: collection_model_write_1.IkeModelCollectionWriter.writeCollectionMeasurements(model),
            brightnessCorrections: collection_model_write_1.IkeModelCollectionWriter.writeCollectionBrightnessCorrections(model),
            cropParameters: collection_model_write_1.IkeModelCollectionWriter.writeCollectionCropParameters(model),
            imageVisibilities: collection_model_write_1.IkeModelCollectionWriter.writeImageVisibilities(model),
            revision: model.revision,
            collectedBy: model.collectedBy,
            collectedWith: model.collectedWith,
            assignedTo: model.assignedTo,
            collectedAt: core_api_1.ParseJSON.toDate(model.collectedAt),
            createdAt: model.createdAt != null ? model.createdAt.toISOString() : null,
            updatedAt: model.updatedAt != null ? model.updatedAt.toISOString() : null,
            updatedBy: model.updatedBy
        };
        if (model.collectedAt !== model.createdAt && model.collectedAt != null) {
            collectionJSON.data.createdat = model.collectedAt.getTime() / 1000;
        }
        return collectionJSON;
    };
    /**
     * Build a collection summary from a collection model.
     *
     * TODO: `link`, `updatedBy`, and `tags` are not fully implemented.
     */
    IkeModelCollection.prototype.summary = function (model) {
        var summaryObject = {
            objectId: model.id,
            collectionId: model.id,
            revision: model.revision,
            uuid: model.uuid,
            formRevision: model.schema.revision,
            createdAt: model.createdAt.toISOString(),
            updatedAt: model.updatedAt.toISOString(),
            collectedAt: core_api_1.ParseJSON.toDate(model.collectedAt),
            collectedBy: model.collectedBy,
            collectedWith: model.collectedWith,
            assignedTo: model.assignedTo,
            links: collection_provider_1.CollectionProvider.getCollectionIds(model),
            updatedBy: [model.updatedBy],
            title: model.title,
            subtitle: model.subtitle,
            siteType: model.siteType,
            dropPole: model.dropPole,
            poleLoading: model.poleLoading,
            mapMarkerColor: model.mapMarkerColor,
            status: null,
            location: core_api_1.ParseJSON.toGeoPoint(model.location),
            captureIds: capture_provider_1.CaptureProvider.getCaptureIds(model),
            tags: [model.jobId]
        };
        var statusField = model.status;
        if (statusField != null) {
            if (statusField.hasValue()) {
                summaryObject.status = statusField.displayValue;
            }
        }
        return summaryObject;
    };
    IkeModelCollection.prototype.getCaptureUUIDs = function (collection) {
        var collectionCaptureData = ReadUtil.findObjectsWhere(collection, ReadUtil.isCaptureData);
        var uuidMap = {};
        for (var _i = 0, collectionCaptureData_1 = collectionCaptureData; _i < collectionCaptureData_1.length; _i++) {
            var captureData = collectionCaptureData_1[_i];
            var uuid = captureData.camera.imageuuid;
            if (uuid != null && !uuidMap[uuid]) {
                uuidMap[uuid] = true;
            }
        }
        return Object.keys(uuidMap);
    };
    IkeModelCollection.prototype.getLinkUUIDs = function (collection) {
        var collectionLinkData = ReadUtil.findObjectsWhere(collection, ReadUtil.isLink);
        var uuidMap = {};
        for (var _i = 0, collectionLinkData_1 = collectionLinkData; _i < collectionLinkData_1.length; _i++) {
            var linkData = collectionLinkData_1[_i];
            var uuid = linkData.collectionUuid;
            if (uuid != null && !uuidMap[uuid]) {
                uuidMap[uuid] = true;
            }
        }
        return Object.keys(uuidMap);
    };
    IkeModelCollection.prototype.getCalibrationIds = function (captures) {
        var calibrationIdMap = {};
        for (var _i = 0, captures_1 = captures; _i < captures_1.length; _i++) {
            var capture = captures_1[_i];
            var calibrationId = capture.calibrationid;
            if (calibrationId != null && !calibrationIdMap[calibrationId]) {
                calibrationIdMap[calibrationId] = true;
            }
        }
        return Object.keys(calibrationIdMap);
    };
    IkeModelCollection.prototype.getFileIds = function (collection) {
        var collectionFileData = ReadUtil.findObjectsWhere(collection, ReadUtil.isFileData);
        var idMap = {};
        for (var _i = 0, collectionFileData_1 = collectionFileData; _i < collectionFileData_1.length; _i++) {
            var fileData = collectionFileData_1[_i];
            var id = fileData.attachmentId;
            if (id != null && !idMap[id]) {
                idMap[id] = true;
            }
        }
        return Object.keys(idMap);
    };
    /** v3 collections have had their captures extracted into the capture file table */
    IkeModelCollection.JSON_VERSION_3_PARSE_API = 3;
    /** v4 Collections have re-mapped their captures to include the objectId and raw values of the actual capture. */
    IkeModelCollection.JSON_VERSION_4_CAPTURE_FIXED = 4;
    /** v5 Collections  */
    IkeModelCollection.JSON_VERSION_5_BRIGHTNESS_CORRECTION_ADDED = 5;
    /** v6 Collections  */
    IkeModelCollection.JSON_VERSION_6_CROP_PARAMETER_ADDED = 6;
    IkeModelCollection.JSON_VERSION_LATEST = 6;
    return IkeModelCollection;
}());
exports.IkeModelCollection = IkeModelCollection;
//# sourceMappingURL=collection.model.js.map